import { Layer, type LayerProps } from 'react-map-gl';

/**
 * Wrapper de `<Layer>` que omite `filter` cuando es undefined.
 *
 * Mapbox style validation rechaza `filter: undefined` con
 * "array expected, undefined found" y la capa nunca se agrega → invisible
 * y no clickeable. React no excluye props undefined automáticamente, así que
 * cada caller necesitaría hacer spread condicional manual (bug latente que
 * ya nos costó visibilidad de parcelas en landing/dashboard).
 *
 * Usar SIEMPRE en lugar de `<Layer>` cuando el filter sea calculado/opcional.
 */
export function FilteredLayer(props: LayerProps) {
  const { filter, ...rest } = props;
  if (filter === undefined) {
    return <Layer {...(rest as LayerProps)} />;
  }
  // El spread + filter estrechado por aparte evita `filter: undefined`; el cast
  // reconcilia el union grande de Mapbox (react-map-gl) con el branch `filter` presente.
  return <Layer {...({ ...rest, filter } as LayerProps)} />;
}
